import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

// Built-in PowerPoint slide viewer. Renders slide text + images extracted server-side
// from the .pptx — no download, no PowerPoint required.
export default function PptSlides({ slides, fileName, testid = "ppt-viewer" }) {
  const [idx, setIdx] = useState(0);
  if (!slides || slides.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-sm text-muted-foreground p-6 text-center" data-testid={`${testid}-empty`}>
        This presentation has no slides.
      </div>
    );
  }
  const slide = slides[Math.min(idx, slides.length - 1)];

  return (
    <div className="h-full flex flex-col" data-testid={testid}>
      <div className="flex items-center justify-between gap-2 px-3 py-2 border-b bg-background">
        <div className="flex items-center gap-1">
          <Button size="sm" variant="outline" disabled={idx === 0} onClick={() => setIdx((i) => Math.max(0, i - 1))} data-testid={`${testid}-prev`}>
            <CaretLeft size={14} />
          </Button>
          <span className="text-xs text-muted-foreground min-w-[90px] text-center" data-testid={`${testid}-slide-indicator`}>
            Slide {slide.n} of {slides.length}
          </span>
          <Button size="sm" variant="outline" disabled={idx >= slides.length - 1} onClick={() => setIdx((i) => Math.min(slides.length - 1, i + 1))} data-testid={`${testid}-next`}>
            <CaretRight size={14} />
          </Button>
        </div>
        <span className="text-xs text-muted-foreground truncate max-w-[40%]">{fileName}</span>
      </div>

      <div className="flex-1 overflow-auto bg-muted/40 p-4">
        <div className="bg-white rounded-md shadow-md max-w-3xl mx-auto p-8 min-h-[300px]" data-testid={`${testid}-slide`}>
          {slide.texts.length === 0 && slide.images.length === 0 && (
            <p className="text-sm text-muted-foreground text-center py-10">(blank slide)</p>
          )}
          {slide.texts.map((t, i) => {
            const lines = t.split("\n");
            return (
              <div key={i} className="mb-4">
                {i === 0 ? (
                  <h3 className="text-xl font-semibold mb-2 whitespace-pre-wrap">{lines[0]}</h3>
                ) : null}
                <div className={i === 0 ? "text-sm whitespace-pre-wrap leading-relaxed" : "text-sm whitespace-pre-wrap leading-relaxed"}>
                  {i === 0 ? lines.slice(1).join("\n") : t}
                </div>
              </div>
            );
          })}
          {slide.images.map((img, i) => (
            <img
              key={i}
              src={`data:${img.mime};base64,${img.b64}`}
              alt={`Slide ${slide.n} image ${i + 1}`}
              className="max-w-full rounded border my-3"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
